"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useElevationChildOverrides = exports.ElevationProvider = exports.ElevationChildrenProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _PaletteConfigProvider = require("../palette/PaletteConfigProvider");
var _useSpectrum = require("../spectrum/useSpectrum");
var _elevation = require("../tokens/elevation");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable react/jsx-no-useless-fragment */

const ElevationContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const ElevationChildContext = /*#__PURE__*/(0, _react.createContext)(false);
const ElevationProvider = /*#__PURE__*/(0, _react.memo)(({
  elevation,
  children
}) => {
  const spectrum = (0, _useSpectrum.useSpectrum)();
  if (elevation) {
    return /*#__PURE__*/_react.default.createElement(ElevationContext.Provider, {
      value: elevation
    }, /*#__PURE__*/_react.default.createElement(_PaletteConfigProvider.PaletteConfigProvider, {
      value: spectrum === 'dark' ? _elevation.elevationPalette[elevation] : undefined
    }, children));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
});
exports.ElevationProvider = ElevationProvider;
const ElevationChildrenProvider = /*#__PURE__*/(0, _react.memo)(({
  children
}) => {
  /** Check if child of Elevated surface */
  const elevation = (0, _react.useContext)(ElevationContext);
  /** Only apply overrides to children in dark mode */
  const spectrum = (0, _useSpectrum.useSpectrum)();

  /** This overrides the palette value for line - Increase brightness of lines in level2 so they appear closer to light source. */
  if (elevation === 2 && spectrum === 'dark') {
    return /*#__PURE__*/_react.default.createElement(ElevationChildContext.Provider, {
      value: true
    }, /*#__PURE__*/_react.default.createElement(_PaletteConfigProvider.PaletteConfigProvider, {
      value: _elevation.elevationChildrenPalette[elevation]
    }, children));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children);
});
exports.ElevationChildrenProvider = ElevationChildrenProvider;
const useElevationChildOverrides = () => (0, _react.useContext)(ElevationChildContext);
exports.useElevationChildOverrides = useElevationChildOverrides;
ElevationProvider.displayName = 'ElevationProvider';
ElevationChildrenProvider.displayName = 'ElevationChildrenProvider';